import { AfterContentInit, Directive, ElementRef, Input } from "@angular/core";
import { UiTooltipDirective } from "./tooltip.directive";
import { UiTooltipTrigger } from "./tooltip.models";

@Directive({
  selector: "[ui-tooltip][tooltipIfOverflow]",
})
export class TooltipIfOverflowDirective implements AfterContentInit {
  @Input("tooltipIfOverflow") public tooltipTrigger: UiTooltipTrigger;
  constructor(private tooltip: UiTooltipDirective, private elementRef: ElementRef<HTMLElement>) {}

  public ngAfterContentInit(): void {
    const { clientWidth, scrollWidth } = this.elementRef.nativeElement;
    const isWidthOverflowing = scrollWidth > clientWidth;

    this.tooltip.trigger = isWidthOverflowing ? this.tooltipTrigger : null;
  }
}
